import apiClient from '../../config/api';

export interface GdprDocument {
  name: string;
  langCode: string;
  version: number;
  content: string;
  updatedAt: string | null;
}

/** Ambas listas bloquean el acceso hasta que se aceptan. */
export interface GdprStatus {
  /** Nunca aceptados. */
  pending: GdprDocument[];
  /** Aceptados solo en una versión anterior. */
  updated: GdprDocument[];
}

/** `acknowledged` es histórico: ya no se emite. */
type ConsentDecision = 'accepted' | 'acknowledged';

class GdprService {
  async getDocuments(langCode: string): Promise<GdprDocument[]> {
    const response = await apiClient.get<{ documents: GdprDocument[] }>('/gdpr/documents', {
      params: { lang_code: langCode },
    });
    return response.data.documents;
  }

  async getStatus(langCode: string): Promise<GdprStatus> {
    const response = await apiClient.get<GdprStatus>('/gdpr/status', {
      params: { lang_code: langCode },
    });
    return response.data;
  }

  async recordConsents(documents: GdprDocument[], decision: ConsentDecision): Promise<void> {
    await apiClient.post('/gdpr/consents', {
      decision,
      documents: documents.map(({ name, version, langCode }) => ({ name, version, langCode })),
    });
  }
}

export const gdprService = new GdprService();
